const INITIAL_STATE = {
  list: {}
};

const scoreReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SCORE_ADD':
      const exists = state.list[action.payload.key];
      const value = {
        [action.payload.key]: exists
          ? {
              ...exists,
              [action.payload.value.startTime]: action.payload.value
            }
          : { [action.payload.value.startTime]: action.payload.value }
      };
      return {
        list: { ...state.list, ...value }
      };
    default:
      return state;
  }
};

export default scoreReducer;
